<template>
  <div class="klantbeeldformulier-page">
    <div class="klantbeeldformulier-page__container">
      <ElementsHeroText
        class="klantbeeldformulier-page__hero"
        title-color="secondary"
        :data="{
          title: pageData.title,
          body: pageData.body,
          button: pageData.link,
        }"
      />

      <div class="klantbeeldformulier-page__wrapper">
        <ElementsTextImageBlock v-if="pageData.textImageBlock?.length" :data="pageData.textImageBlock[0]" />
      </div>

      <ElementsAccordion v-if="pageData.accordionBlock[0]" :data="pageData.accordionBlock[0]" />
    </div>
  </div>
</template>

<script lang="ts" setup>
import { storeToRefs } from "pinia";
import { useGlobalStore } from "@/stores/global";

const { content } = storeToRefs(useGlobalStore());

const pageData = computed(() => {
  return content.value.data.klantbeeldformulierPage as KlantbeeldformulierPageRecord;
});
</script>

<style lang="scss">
$component: "klantbeeldformulier-page";

.#{$component} {
  display: flex;
  justify-content: center;

  &__container {
    width: 100%;
  }

  &__wrapper {
    background: $color-light-blue--pale;
    padding: 60px clamp(2rem, 5vw, 3rem) 70px clamp(2rem, 5vw, 3rem);
  }
}
</style>
